import React from 'react'
import { connect } from 'react-redux'
import { compose, withProps, withState } from 'recompose'
import { withTranslation } from 'react-i18next'
import { Manager, Popper, Reference } from 'react-popper'
import { moveItem } from '../../../store/actions/tree'
import { moveToSelector } from '../../../store/selectors/accessSelectors'
import ReactDOM from 'react-dom'
import { space } from '../../../style';

const withMenu = ({ popperProps }) => Component => ({
  menuShowing,
  showMenu,
  hideMenu,
  ...props
}) => (
  <Manager>
    {menuShowing &&
      ReactDOM.createPortal(
        <Popper {...popperProps}>
          {({ ref, style }) => (
            <Component {...props} storeRef={ref} style={style} />
          )}
        </Popper>,
        document.body
      )}
    {/* Popper first so it gets put in the DOM before Reference
      Reference must be last-child for styling */}
    <Reference>
      {({ ref }) =>
        props.children({ ref, onMouseEnter: showMenu, onMouseLeave: hideMenu })
      }
    </Reference>
  </Manager>
)

export const MoveMenuLevelContainer = compose(
  withProps(({ setCurrentFolders, currentFolders, path = [], ...props }) => ({
    // add self to path inherited from parent
    path: [...path, props.folderId],
    subfolders: props.moveList[props.folderId],
    hasChildren: folderId => folderId in props.moveList,
    menuShowing: currentFolders.includes(props.folderId),
    showMenu: () => {
      // if this folder is in the list then it has children
      if (props.folderId in props.moveList) {
        // add this folder to the path
        setCurrentFolders([...path, props.folderId])
      } else {
        // set the path to path inherited from parent
        setCurrentFolders(path)
      }
    }
  })),
  withMenu({
    popperProps: {
      placement: 'right-start',
      // positionFixed: true,
      modifiers: {
        offset: { enabled: true, offset: '0, 2' },
        preventOverflow: { boundariesElement: 'viewport', padding: space.large }
      }
    }
  })
)

export default compose(
  connect(
    (state, { item }) => ({
      moveList: moveToSelector(state, item.id)
    }),
    (dispatch, { item }) => ({
      moveItem: folder => {
        dispatch(moveItem({ id: item.id, folder }))
      }
    })
  ),
  withState('currentFolders', 'setCurrentFolders', []),
  withTranslation()
)
